<div class="container p-5">
    <div class="row">
        <h1 class="mb-1">Set your integrations</h1>
        <h4>Your assistant will be able to interact with these systems during calls</h4>
    </div>
    
    <!-- Add integration button -->

    <div class="row">
        <div class="col-12 d-flex justify-content-end mb-5">
            <button mat-raised-button extended (click)="onAddIntegration()">
                <mat-icon>add</mat-icon>
                Add Integration
            </button>
        </div>
    </div>

    <!-- Filter -->

    <div class="row">
        <div class="col-12">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Filter By name</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Zapier" #input>
                <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
        </div>
    </div>

    <!-- List of Integrations -->

    <div class="container">
        <div class="row">
            <div class="col-4 p-3" *ngFor="let integration of filteredIntegrations; let i = index">
                <div class="d-flex flex-column justify-content-around mat-elevation-z2 mt-2 mb-2 rounded p-3">
                    <mat-icon class="align-self-center mb-2" style="width: 30%;height:70px;" [svgIcon]="integration.icon"></mat-icon>
                    <p><span class="fw-bold">Name: </span>{{integration.name}}</p>
                    <div class="d-flex mt-5 justify-content-around">
                        <button [disabled]="isLoading || !integration.isEditable" style="width: 35%;" mat-raised-button (click)="integration.editCallBack()">Edit</button>
                        <button [disabled]="isLoading" style="width: 35%;" color="warn" mat-raised-button (click)="integration.deleteCallBack()">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>